module.exports = __webpack_public_path__ + "img/DGB.51f7abce.svg";